<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <!--      src="@/assets/images/uploads/isbank_logo.svg"-->

    <div class="bookmark-wrapper align-items-center flex-grow-1 d-lg-flex">
      <img
        :src="logoURL"
        style="height: 40px; margin-left: .6rem !important;"
      >
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!--<dark-Toggler class="d-none d-lg-block" /> -->
      <dev-warning v-if="isDev"/>
      <search-bar />
      <!--<notification-dropdown />-->
      <notification-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav
} from 'bootstrap-vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DevWarning from './components/DevWarning.vue'
import DarkToggler from './components/DarkToggler.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import UserDropdownItems from './components/UserDropdownItems.vue'
import { initialAbility } from '@/libs/acl/config'
import { Auth, Hub } from 'aws-amplify'

export default {
  components: {
    BLink,
    // Navbar Components
    BNavbarNav,
    Locale,
    DevWarning,
    SearchBar,
    NotificationDropdown,
    UserDropdown,
    UserDropdownItems,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    logoURL() {
      return this.$store.getters['adinSettings/getLogoURL']
    },
    isDev(){
      return process.env.NODE_ENV === 'development'  
    }
  },
}
</script>

<style lang="scss" scoped>
.user-profile-section {
  min-width: 120px;
}
</style>
